
// import aes from 'crypto-js/aes'
// import * as aesjs from '../libs/aes'

export default class UtilsDecrypt {

    encKey = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16 ];
    encCounter = 5

   encryptText=(tx, activeLog = null)=>{

       let aesjs = require('../libs/aes')

       // Convert text to bytes
       var textBytes = aesjs.utils.utf8.toBytes(tx);

       // The counter is optional, and if omitted will begin at 1
       var aesCtr = new aesjs.ModeOfOperation.ctr(this.encKey, new aesjs.Counter(this.encCounter));
       var encryptedBytes = aesCtr.encrypt(textBytes);

       // To print or store the binary data, you may convert it to hex
       var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);

       if(activeLog){
        //    console.log("aes ENCRYPTION function will return: " , encryptedHex )
       }
       
       return encryptedHex
   }

   decryptText = (encryptedHex,activeLog)=>{

       let aesjs = require('../libs/aes')
       var encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex);

       var aesCtr = new aesjs.ModeOfOperation.ctr(this.encKey, new aesjs.Counter(this.encCounter));
       var decryptedBytes = aesCtr.decrypt(encryptedBytes);

       // Convert our bytes back into text
       var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);

       if(activeLog){

        //    console.log("aes DECRYPT function will return: ",decryptedText);
       }

       return decryptedText
   }

}